const hasDateInputCapability = () => {
  const input = document.createElement('input')
  input.setAttribute('type', 'date')
  return input.type === 'date'
}

export default {
  dateInput: hasDateInputCapability(),
}
